import { Button } from '@/components/ui/button';
import { Select } from '@/components/ui/select';
import type { UserReference } from '@/features/leads/types';

interface JobFiltersProps {
  onFilterChange: (filter: FilterType) => void;
  onAssignedToChange: (userId: number | undefined) => void;
  currentFilter: FilterType;
  users: UserReference[];
  selectedAssignedToId?: number;
}

export type FilterType = 'all-active' | 'closed' | 'collections' | 'all' | 'by-estimator';

export function JobFilters({
  onFilterChange,
  onAssignedToChange,
  currentFilter,
  users,
  selectedAssignedToId,
}: JobFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        onClick={() => onFilterChange('all-active')}
        className={
          currentFilter === 'all-active'
            ? 'bg-secondary text-white hover:bg-secondary/90 rounded-[50px] px-6'
            : 'bg-muted text-foreground hover:bg-muted/80 rounded-[50px] px-6'
        }
      >
        All Active
      </Button>

      <Button
        onClick={() => onFilterChange('closed')}
        className={
          currentFilter === 'closed'
            ? 'bg-secondary text-white hover:bg-secondary/90 rounded-[50px] px-6'
            : 'bg-muted text-foreground hover:bg-muted/80 rounded-[50px] px-6'
        }
      >
        Closed
      </Button>

      <Button
        onClick={() => onFilterChange('collections')}
        className={
          currentFilter === 'collections'
            ? 'bg-secondary text-white hover:bg-secondary/90 rounded-[50px] px-6'
            : 'bg-muted text-foreground hover:bg-muted/80 rounded-[50px] px-6'
        }
      >
        Collections
      </Button>

      <Button
        onClick={() => onFilterChange('all')}
        className={
          currentFilter === 'all'
            ? 'bg-secondary text-white hover:bg-secondary/90 rounded-[50px] px-6'
            : 'bg-muted text-foreground hover:bg-muted/80 rounded-[50px] px-6'
        }
      >
        All
      </Button>

      <Button
        onClick={() => onFilterChange('by-estimator')}
        className={
          currentFilter === 'by-estimator'
            ? 'bg-secondary text-white hover:bg-secondary/90 rounded-[50px] px-6'
            : 'bg-muted text-foreground hover:bg-muted/80 rounded-[50px] px-6'
        }
      >
        By Estimator
      </Button>

      {currentFilter === 'by-estimator' && (
        <Select
          value={selectedAssignedToId?.toString() || ''}
          onChange={(e) => {
            onAssignedToChange(e.target.value ? Number(e.target.value) : undefined);
          }}
          className="w-48 rounded-[20px]"
        >
          <option value="">Select Estimator</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </Select>
      )}
    </div>
  );
}
